export default __webpack_public_path__ + "img/image-here.png?ee50";